export const initialCardsState = () => ({
  fetchCardsLoading: false,
  fetchCardsFailure: false,
  fetchCardsLoaded: false,
  cardsDetails: {}
});
